import { Injectable } from '@angular/core';
import { AdminGate, GetSessionListRequest } from '../../../../../backend/src/core/admin/admin.gate';
import { ResourceName } from '../../../../../backend/src/core/resource-name';
import { LambdaService } from '../../shared/core/lambda.service';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  readonly resourceName = ResourceName.admin;

  constructor(private lambdaService: LambdaService) {}

  getSessionList$(userId: string) {
    const request: GetSessionListRequest = { userId };
    return this.lambdaService.run$(this.resourceName, AdminGate.actions.getSessionList, request);
  }

  getWorkspaceList$(email: string) {
    return this.lambdaService.run$(this.resourceName, AdminGate.actions.getWorkspaceList, { email });
  }

  getWorkspace$(workspaceId: string) {
    return this.lambdaService.run$(this.resourceName, AdminGate.actions.getWorkspace, { id: workspaceId });
  }

  updateWorkspacePublicSubdata$(workspaceId: string, publicSubdata: any) {
    return this.lambdaService.run$(this.resourceName, AdminGate.actions.updateWorkspacePublicSubdata, {
      workspaceId,
      publicSubdata,
    });
  }
}
